<div class="app-textarea">
  <mat-label class="app-textarea__label">{{label}}:</mat-label>
  <mat-form-field appearance="outline">
    <textarea matInput [formControl]="control" rows="3" [maxlength]="maxlength">
    </textarea>
  </mat-form-field>
</div>
